import InfoPanel from '@/components/common/InfoPanel/InfoPanel'
import InfoItem from '@/components/common/InfoItem/InfoItem'

export default function TaxInformation({storeData}) {
  // Add null check - if tax doesn't exist, use an empty object
  const taxInfo = storeData?.tax || {};

  return (
    <InfoPanel title="Tax" isCollapsible={false} defaultOpen={true} className="mt-4 !px-0">
      <div className="px-4">
        <div className="grid grid-cols-3 gap-y-6">
          <InfoItem label="Tax Area Code" value={taxInfo.taxAreaCode} />
          <InfoItem label="VAT Number" value={taxInfo.vatNumber} />
          <InfoItem label="VAT Registration Date" value={taxInfo.vatRegistrationDate} />

          <InfoItem label="Tax Type" value={taxInfo.taxType} />
          <InfoItem label="Tax ID" value={taxInfo.taxId} />
          <InfoItem label="Sugar Tax" value={taxInfo.sugarTax ? 'Yes' : 'No'} />

          <InfoItem label="Test User" value={taxInfo.isTestUser ? 'Yes' : 'No'} />
        </div>
      </div>
    </InfoPanel>
  )
}
